import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

const IntegrationsAiTableNameCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{item.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableNameCell;
